module.exports = __webpack_public_path__ + "static/media/logo-header.affa1ea2.jpg";